var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading && _vm.alertsArray.length > 0
    ? _c("div", [
        _c("div", { staticClass: "info--text text-uppercase my-3 mt-2" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.generateMessage("requests.details.titles.alerts")) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-simple-table",
              {
                staticClass: "secondarybackground caption text-center",
                style: `max-width: ${_vm.alertsArray.length * 25}%`,
                attrs: { dense: "" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    { staticClass: "font-weight-bold" },
                    _vm._l(_vm.alertsArray, function(item) {
                      return _c("th", { key: item.name }, [
                        _c("div", { staticClass: "d-flex justify-center" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.generateMessage(
                                  `alerts.fields.${item.name}`
                                )
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c(
                    "tr",
                    _vm._l(_vm.alertsArray, function(item) {
                      return _c("td", { key: item.name }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-center my-1" },
                          [
                            _c(
                              "v-chip",
                              { staticClass: "mr-2", attrs: { small: "" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm._f("showDate")(item.date)) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.plan
                              ? _c("link-to-actionplan", {
                                  attrs: {
                                    color: "success",
                                    actionPlanId: item.plan
                                  }
                                })
                              : _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  { attrs: { color: "error" } },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.generateMessage(
                                                          "alerts.icons.remove"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.generateMessage(
                                              "requests.details.titles.no_actionplan"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ]
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(item.desc))])
                      ])
                    }),
                    0
                  )
                ])
              ]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }